import React from "react";
import { PublicShell, BackButton } from "@/components/Layout";
import { Ticket, Wallet, ShieldCheck, ScanLine, Receipt, RotateCcw } from "lucide-react";

const STEPS = [
  { icon: ShieldCheck, n: "01", t: "Merchant signs up", d: "Register with email or SA cellphone. Verify via OTP. Complete KYC by uploading ID, proof of address (and business documents if a Pty Ltd)." },
  { icon: Wallet, n: "02", t: "Wallet top-up", d: "Deposit funds and upload proof of payment. The admin verifies and credits your prepaid float wallet." },
  { icon: Ticket, n: "03", t: "Generate vouchers", d: "Pick any denomination. We mint a cryptographically secure 16-digit PIN. The merchant wallet is debited atomically." },
  { icon: ScanLine, n: "04", t: "Customer redeems", d: "Customer presents PIN. Choose a service (general, airtime, data, electricity, XLearna). Voucher balance decreases — vouchers support multiple partial redemptions." },
  { icon: Receipt, n: "05", t: "Receipt & SMS", d: "Generate a printable / thermal receipt. Customers can optionally be SMS'd voucher PINs and redemption notifications." },
  { icon: RotateCcw, n: "06", t: "Reconcile", d: "The admin dashboard tracks outstanding liability, redemption velocity and merchant balances in real-time, with an immutable audit ledger." },
];

export default function HowItWorks() {
  return (
    <PublicShell>
      <section className="max-w-6xl mx-auto px-5 sm:px-8 py-16">
        <BackButton to="/" label="Back to home" />
        <p className="text-xs tracking-[0.22em] uppercase font-bold text-[#00C4B4]">How it works</p>
        <h1 className="font-display mt-3 text-4xl sm:text-5xl tracking-tight font-bold text-[#0A2540]">
          From sign-up to settlement, in six steps.
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-12">
          {STEPS.map((s) => (
            <div data-testid={`step-${s.n}`} key={s.n} className="bg-white border border-[#E5E7EB] rounded-2xl p-7 hover:shadow-md transition-shadow">
              <div className="flex items-center justify-between">
                <span className="font-mono text-xs text-[#999999]">{s.n}</span>
                <s.icon size={20} className="text-[#00C4B4]" />
              </div>
              <p className="font-display mt-5 text-xl font-semibold text-[#0A2540]">{s.t}</p>
              <p className="text-sm text-[#666666] mt-2 leading-relaxed">{s.d}</p>
            </div>
          ))}
        </div>
      </section>
    </PublicShell>
  );
}
